import * as React from 'react';
import { color } from '@haldi/style-guide';
import classnames from 'classnames';

import { HaldiStickyNote } from '@src/routes/common/components/HaldiStickyNote';
import { IconShape } from '@src/routes/common/icons/IconShape';
import { AppPicture } from '@src/services/app/components/AppPicture';

import styles from './styles.module.css';

export interface AboutPhotosSimranProps {
  className?: string;
}

/**
 * @name AboutPhotosSimran
 * @description These "AboutPhotosXxxx" blocks are used to display some
 * photos of a given team member and help with the arrangement of various
 * Stickers and Sticky Notes which are absolutely positioned.
 */
export const AboutPhotosSimran = (props: AboutPhotosSimranProps) => {
  const { className } = props;

  // Styles
  const tailwind = 'relative';
  const cssComponent = classnames(tailwind, styles.component, className);
  const cssContainer = classnames('ui-container-lg', styles.container);
  const cssBottle = classnames(styles.sticker, styles.bottle);
  const cssSpot = classnames(styles.sticker, styles.spot);

  return (
    <div className={cssComponent}>
      <div className="ui-mobile">
        <div className="bg-white" style={{ height: 80 }} />
      </div>
      <div className={cssContainer}>
        <div className="ui-desktop">
          <AppPicture
            className={styles.image}
            png="/images/rebrand/about-simran-desktop.png"
            webp="/images/webp/about-simran-desktop.webp"
          />
        </div>
        <div className="ui-mobile">
          <AppPicture
            className={styles.image}
            png="/images/rebrand/about-simran-mobile.png"
            style={{ marginTop: -100 }}
            webp="/images/webp/about-simran-mobile.webp"
          />
        </div>
        <IconShape className={cssBottle} fill={color.stormy} shape={6} />
        <IconShape className={cssSpot} fill={color.seaSalt} shape={11} />
        <HaldiStickyNote
          className={styles.sticky}
          fill={color.turmeric}
          flipped={true}
          rotate={-10}
          size="large"
        >
          <div className="text-20 md:p-2x md:text-32">
            Simran at
            <br />
            home in 2018
          </div>
        </HaldiStickyNote>
      </div>
    </div>
  );
};
